import { Paper, Typography, Chip, Stack } from "@mui/material";

const ShiftLegend = ({ shifts, t }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        borderRadius: 3,
        width: "fit-content",
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
      >
        {t("Legend")}
      </Typography>

      <Stack
        direction="row"
        flexWrap="wrap"
        spacing={1}
        useFlexGap
        justifyContent="center"
      >
        {shifts.map((shift) => {
          const abbreviation = shift.name
            .split(" ")
            .map((word) => word[0])
            .join("")
            .toUpperCase();

          return (
            <Chip
              key={shift.id}
              label={`${shift.id} | ${shift.name} (${abbreviation})`}
              color="primary"
              size="small"
              variant="outlined"
              sx={{
                fontWeight: "bold",
                flex: "1 1 calc(50% - 8px)",
                minWidth: 120,
              }}
            />
          );
        })}
      </Stack>
    </Paper>
  );
};

export default ShiftLegend;
